// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// PC端和移动端的公共样式
import './assets/css/common.css'
import './assets/mobileCss/style.css'
import './assets/pcCss/style.css'
import puJS from './utils/publicJS'

Vue.prototype.puJS = puJS
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 是否为手机端
const flag = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
)
// 移动端引入公共样式
if (flag) {
  require('@/assets/mobileCss/style.css')
}
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
// Vue.use(VueAwesomeSwiper)

Vue.use(ElementUI)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js